export default "__VITE_ASSET__CGfdlNYt__"